import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { BadgeCheck, ChevronUp } from 'lucide-react';
import { useState, type FC } from 'react';
import { Source } from './ChatContext';
import { SourceComponent } from './Source';

export const ReferencesSection: FC<{
  messageSources: Source[];
  handleSourceClick: (source: Source) => () => void;
}> = ({ messageSources, handleSourceClick }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const numberOfReferences = messageSources.length;

  return (
    <FlexCol className="w-full mt-6 border border-neutral-200 rounded-lg overflow-hidden">
      {/* References Header */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="flex items-center justify-between w-full px-3 py-3 hover:bg-neutral-50 transition-colors"
      >
        <FlexRow className="items-center gap-2">
          <BadgeCheck className="w-5 h-5 fill-yellow-400" />
          <Text
            className="font-medium text-neutral-900 text-base"
            style={{ fontFamily: 'inherit' }}
          >
            {numberOfReferences} verified{' '}
            {numberOfReferences === 1 ? 'source' : 'sources'}
          </Text>
        </FlexRow>
        <div className="p-1 rounded">
          <ChevronUp
            className={`w-4 h-4 text-neutral-900 transition-transform ${
              isCollapsed ? 'transform rotate-180' : ''
            }`}
          />
        </div>
      </button>

      {!isCollapsed && (
        <FlexCol className="pb-2">
          {messageSources.map((source, idx) => (
            <div key={idx}>
              {idx > 0 && <div className="mx-4 border-t border-neutral-100" />}
              <div className="px-4">
                <SourceComponent
                  key={
                    source.type === 'file'
                      ? `file-${source.fileId}-${source.pageNumber}-${idx}`
                      : `database-${source.databaseId}-${idx}`
                  }
                  source={source}
                  citationNumber={idx + 1}
                  onSourceClick={handleSourceClick(source)}
                />
              </div>
            </div>
          ))}
        </FlexCol>
      )}
    </FlexCol>
  );
};
